export const useDeviceDetails = () => {
  const userAgent = navigator.userAgent || navigator.vendor;

  return {
    os: /iPad|iPhone/.test(userAgent) ? 'IOS' : 'Android',
    isStandalone: window.matchMedia('(display-mode: standalone)').matches,
  };
};
